export default __webpack_public_path__ + "static/media/SENAIT_FR_EPILOG1.e98cbce3.mp3";